var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnarchiveModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6 10.44L38.82 7.08C38.26 6.42 37.44 6 36.5 6H12.5C11.56 6 10.74 6.42 10.2 7.1L7.42 10.44C6.84 11.14 6.5 12.02 6.5 13V38C6.5 40.2 8.28 42 10.5 42H38.5C40.7 42 42.5 40.2 42.5 38V13C42.5 12.02 42.16 11.14 41.6 10.44ZM24.5 19L35.5 30H28.5V34H20.5V30H13.5L24.5 19ZM10.74 10L12.38 8H36.38L38.24 10H10.74Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchiveModalIcon);
export default __webpack_public_path__ + "static/media/UnarchiveModalIcon.fbe5203b7ce46f2d1c623eb6cf3bb3a0.svg";
export { ForwardRef as ReactComponent };